import { ToEntity } from 'core/common/mappers';
import {
  CardBrand,
  CardType,
  PaymentError,
  PaymentMethod,
  PaymentStatus,
  PaymentType,
  ResignFormData,
} from '../entities';
import { PaymentStatusDto } from '../services/dto';

export class PaymentStatusDtoMapper implements ToEntity<PaymentStatus, PaymentStatusDto> {
  toEntity(dto: PaymentStatusDto): PaymentStatus {
    return {
      order_id: dto.id,
      status: dto.status,
      error: this.mapError(dto.error),
      paymentMethod: this.mapPaymentMethod(dto.payment_method),
      resignFormData: this.mapResignFormData(dto.resign_payment),
      recurringData: this.mapRecurringData(dto.resign_payment, dto.verify_url),
    };
  }

  private mapPaymentMethod(paymentMethod: PaymentStatusDto['payment_method']): PaymentMethod {
    return {
      cardBank: paymentMethod?.card_bank ?? '',
      cardBrand: paymentMethod?.card_brand ?? CardBrand.UNKNOWN,
      cardType: paymentMethod?.card_type ?? CardType.UNKNOWN,
      type: paymentMethod?.type ?? PaymentType.CARD,
    };
  }

  private mapError(error: PaymentStatusDto['error']): PaymentError {
    return {
      message: error?.message ?? '',
      code: error?.code,
      details: error?.details,
    };
  }

  private mapResignFormData(resignPayment: PaymentStatusDto['resign_payment']): ResignFormData {
    return {
      merchant: resignPayment?.payment_form?.merchant ?? '',
      resignIntent: resignPayment?.payment_form?.resignIntent ?? '',
      signature: resignPayment?.payment_form?.signature ?? '',
    };
  }

  private mapRecurringData(
    resignPayment: PaymentStatusDto['resign_payment'],
    verifyUrl: PaymentStatusDto['verify_url'],
  ) {
    return {
      verifyUrl: verifyUrl ?? '',
      resignUrl: resignPayment?.payment_page_url ?? '',
      tokenId: resignPayment?.payment_id ?? '',
    };
  }
}
